import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useToken } from '@hub/design-system-base';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { H2 } from '@hub/heading';
import { LinkButtonOverlay, LinkOverlay } from '@hub/link';
import trackEvents, { categories } from '../analytics/trackEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContentStack = ({
  sx,
  title,
  shortDescription,
  callToActionLabel,
  url,
  color,
  centered = false,
  textShadow,
  position
}) => {
  const defaultColor = useToken('colors', 'licorice');
  const hoverColor = useToken('colors', defaultColor === color ? 'quartz' : 'ghost');
  return /*#__PURE__*/_jsxs(Stack, {
    shouldWrapChildren: false,
    sx: _objectSpread(_objectSpread({}, !centered && {
      alignItems: 'flex-start'
    }), sx),
    gap: "spacing-md",
    children: [/*#__PURE__*/_jsxs(Stack, {
      shouldWrapChildren: false,
      gap: "spacing-sm",
      children: [/*#__PURE__*/_jsx(H2, {
        align: centered ? 'center' : 'left',
        sx: {
          color,
          textShadow
        },
        children: !callToActionLabel && url ? /*#__PURE__*/_jsx(LinkOverlay, {
          href: url,
          children: title
        }) : title
      }), shortDescription ? /*#__PURE__*/_jsx(Text, {
        align: centered ? 'center' : 'left',
        sx: {
          color,
          textShadow
        },
        children: shortDescription
      }) : null]
    }), callToActionLabel && url ? /*#__PURE__*/_jsx(LinkButtonOverlay, {
      href: url,
      variant: "outline",
      sx: {
        borderColor: color,
        color,
        '&:hover': {
          textDecoration: 'none',
          '@media (hover: hover)': {
            borderColor: hoverColor,
            color: hoverColor
          }
        }
      },
      onClick: () => trackEvents.clicked(categories.FEATURE_CAROUSEL, "".concat(title, " | P").concat(position)),
      children: callToActionLabel
    }) : null]
  });
};